export const isGuid = (str) => {
  // GUID regex pattern
  const pattern = new RegExp('^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$');

  // Check if the string matches the GUID pattern
  return pattern.test(str);
};
